import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Вони не просто зробили ідеальну подію, вони перевершили всі наші очікування. Рівень сервісу, який важко знайти навіть у Європі.',
  author: 'Олена В.',
  role: 'CEO, Tech Innovators'
}, {
  quote: 'Кожна деталь нашого весілля була бездоганною. Це була справжня магія, створена командою професіоналів.',
  author: 'Максим та Анна',
  role: 'Приватні клієнти'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-32 md:py-48 bg-surface relative overflow-hidden border-b border-border" data-id="element-164">
      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-165">
        <div className="text-center mb-24" data-id="element-166">
          <h2 className="text-secondary uppercase tracking-super-wide text-[10px] font-sans mb-6" data-id="element-167">
            Відгуки
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 md:gap-32 max-w-6xl mx-auto" data-id="element-168">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: index * 0.2
        }} className="flex flex-col" data-id="element-169">
              <p className="text-2xl md:text-4xl font-serif text-primary leading-relaxed mb-12 flex-grow italic font-light" data-id="element-170">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-6" data-id="element-171">
                <div className="w-12 h-[1px] bg-border" data-id="element-172"></div>
                <div data-id="element-173">
                  <p className="font-sans text-primary uppercase tracking-widest text-[11px] mb-2" data-id="element-174">
                    {item.author}
                  </p>
                  <p className="font-sans text-secondary text-[10px] uppercase tracking-widest" data-id="element-175">
                    {item.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}